import { render, staticRenderFns } from "./ParentFicheReclamation.vue?vue&type=template&id=340ed349&"
import script from "./ParentFicheReclamation.vue?vue&type=script&lang=js&"
export * from "./ParentFicheReclamation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports